<template>
	<div class="w-64 p-4 bg-background border border-border rounded-lg shadow-md space-y-4">
		<h2 class="text-lg font-semibold">Available Components</h2>
		<div v-for="comp in components" :key="comp.type" class="p-3 bg-muted rounded hover:bg-muted/60 cursor-pointer" @click="$emit('add', comp)" >
			<div class="w-full flex justify-between items-center">
				<div>
					{{ comp.name }} 
				</div>
			<div>
				<PlusCircleOutlineIcon class="h-8 w-8 text-primary"/>
			</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import PlusCircleOutlineIcon from 'vue-material-design-icons/PlusCircleOutline.vue';
import { availableComponents as components } from '@/data/dashboard'
defineEmits(['add'])
</script>

